import { useCallback, useEffect, useState } from 'react'

/** A flag that stays on for the given milliseconds after `start`, cleared on unmount. */
export function useTimedFlag(): [boolean, (ms: number) => void] {
  const [until, setUntil] = useState(0)

  useEffect(() => {
    if (!until) return
    const timeout = setTimeout(() => setUntil(0), Math.max(0, until - Date.now()))
    return () => clearTimeout(timeout)
  }, [until])

  const start = useCallback((ms: number) => setUntil(Date.now() + ms), [])
  return [until > 0, start]
}
